module.exports = __webpack_public_path__ + "img/feature-tile-icon-04.d63b36a8.svg";